import React from "react";
import styled from "styled-components";
import DatePicker from "react-date-picker";
import moment from "moment";

function DateInput(props) {
  const onChange = (data) => {
    props.onChange(data);
  };

  return (
    <StyledDateInput className={`${props.className} form__option`}>
      <label htmlFor={props.name}>
        {props.title}
        {props.important && <span style={{ color: "red" }}>*</span>}
        {props.showAttention ? (
          <div className="input-attention fade-in-fwd">
            {props.attentionText}
          </div>
        ) : (
          ""
        )}
      </label>
      <DatePicker
        onChange={onChange}
        disableCalendar
        name={props.name}
        id={props.name}
        format="d.M.y"
        value={props.value ? new Date(props.value) : ""}
        className={"form-input"}
        clearIcon={false}
        maxDate={new Date()}
        minDate={new Date(moment("01.01.1900", "DD.MM.YYYY"))}
        yearPlaceholder={"гггг"}
        dayPlaceholder={"дд"}
        monthPlaceholder={"мм"}
      />
    </StyledDateInput>
  );
}

const StyledDateInput = styled.div`
  _ * {
    font-weight: normal;
  }

  label {
    font-weight: bold;
  }

  .react-date-picker__wrapper {
    border: 0 solid black;
  }

  .react-date-picker__inputGroup__input {
    outline: none;
    font-weight: normal;

    ::placeholder {
      color: black;
    }
  }
`;

export default DateInput;
